
// How the supplier's documents are read by the document extraction (DocumentExtractionOptions
// of the legal entity): prices printed with VAT included, and the lines grouped into one custom
// line booked to a concept. The row is made the first time an option is set.

class SupplierDocumentReadingViewController extends MUIViewController
{
    static newInstance() : SupplierDocumentReadingViewController {
        let vc = new SupplierDocumentReadingViewController("supplier-document-reading-view");
        vc.initWithResource("layout/supplier/SupplierDocumentReadingView.html");
        return vc;
    }

    private pricesIncludeTaxSwitch:MUISwitchButton = null;
    private groupLinesSwitch:MUISwitchButton = null;
    private groupLinesConceptDropdown:MUIButton = null;
    private summaryOnlySwitch:MUISwitchButton = null;
    private summaryTableTextField:MUITextField = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.pricesIncludeTaxSwitch = MUIOutlet(this, "prices-include-tax-sb", "MUISwitchButton");
        this.pricesIncludeTaxSwitch.setOnChangeValue(this, function(this:SupplierDocumentReadingViewController, control:MUISwitchButton, value:boolean){
            if (this._supplier == null) return;
            this.extractionOptions.pricesIncludeTax = value;
            DBHelper.saveMainContext();
        });

        this.groupLinesSwitch = MUIOutlet(this, "group-lines-sb", "MUISwitchButton");
        this.groupLinesSwitch.setOnChangeValue(this, function(this:SupplierDocumentReadingViewController, control:MUISwitchButton, value:boolean){
            if (this._supplier == null) return;
            this.extractionOptions.groupLines = value;
            DBHelper.saveMainContext();
        });

        // the summary table only: the reading ignores the detailed listings (applies from the next reading)
        this.summaryOnlySwitch = MUIOutlet(this, "summary-only-sb", "MUISwitchButton");
        this.summaryOnlySwitch.setOnChangeValue(this, function(this:SupplierDocumentReadingViewController, control:MUISwitchButton, value:boolean){
            if (this._supplier == null) return;
            this.extractionOptions.summaryOnly = value;
            this.summaryTableTextField.enabled = value;
            DBHelper.saveMainContext();
        });
        this.summaryTableTextField = MUIOutlet(this, "summary-table-tf", "MUITextField");
        this.summaryTableTextField.setOnChangeText(this, function(this:SupplierDocumentReadingViewController, control:MUITextField, value:string){
            if (this._supplier == null) return;
            let text = (value ?? "").trim();
            this.extractionOptions.summaryTable = text.length > 0 ? text : null;
        });

        this.groupLinesConceptDropdown = MUIOutlet(this, "group-lines-concept-dd", "MUIButton");
        this.groupLinesConceptDropdown.setAction(this, function(this:SupplierDocumentReadingViewController){
            if (this._supplier == null) return;
            let vc = AppHelper.sharedInstance().selectViewController("ConceptItem", "name", true, false, null, this, null) as SelectEntityViewController;
            AppHelper.sharedInstance().allowAddingConceptItem(vc, (concept:ConceptItem) => this.didSelectObjectFromSelectViewController(vc, concept));
            vc.modalPresentationStyle = MUIModalPresentationStyle.Popover;
            let pc = vc.popoverPresentationController;
            pc.sourceRect = this.groupLinesConceptDropdown.frame;
            pc.sourceView = this.groupLinesConceptDropdown;
            this.presentViewController(vc, true);
        });
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _supplier:Supplier = null;
    set supplier(value:Supplier){
        this._supplier = value;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._supplier == null) return;
        let options = this._supplier.extractionOptions;
        this.pricesIncludeTaxSwitch.on = options != null && options.pricesIncludeTax == true;
        this.groupLinesSwitch.on = options != null && options.groupLines == true;
        this.groupLinesConceptDropdown.title = options?.groupLinesConcept?.name ?? MIOLocalizeString("SELECT", "Select");
        this.summaryOnlySwitch.on = options != null && options.summaryOnly == true;
        this.summaryTableTextField.text = options?.summaryTable ?? null;
        this.summaryTableTextField.enabled = options != null && options.summaryOnly == true;
    }

    // The row the options live in, made on first use.
    private get extractionOptions() : DocumentExtractionOptions {
        if (this._supplier.extractionOptions == null) {
            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
            let options = MIOEntityDescription.insertNewObjectForEntityForName("DocumentExtractionOptions", moc) as DocumentExtractionOptions;
            options.legalEntity = this._supplier;
            this._supplier.extractionOptions = options;
        }
        return this._supplier.extractionOptions;
    }

    // Select entity view controller (the custom line concept)

    fetchRequestForController(controller:SelectEntityViewController) : MIOFetchRequest {
        if (controller.identifier == "ConceptItem") {
            let sd = [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
            return DBHelper.listFetchRequestWithEntityName("ConceptItem", sd, MIOPredicate.predicateWithFormat("deletedAt = null"));
        }
        return null;
    }

    didSelectObjectFromSelectViewController(controller:SelectEntityViewController, item:MIOManagedObject) : boolean {
        if (controller.identifier == "ConceptItem") {
            let concept = item as ConceptItem;
            this.extractionOptions.groupLinesConcept = concept;
            this.groupLinesConceptDropdown.title = concept != null ? concept.name : MIOLocalizeString("SELECT", "Select");
            DBHelper.saveMainContext();
        }
        return true;
    }
}
